import { toast } from 'react-hot-toast';

export const errorToast = (message = 'Something went wrong!') =>
	toast.error(message, {
		style: {
			border: 'none',
			padding: '16px',
			color: 'white',
			background: '#E5170B',
			boxShadow: 'none',
			borderRadius: 20,
			width: 'calc(100vw - 40px)',
			maxWidth: 700,
			height: 54,
			textAlign: 'left',
		},
		duration: 2000,
	});

export const successToast = (message = 'Success') =>
	toast.success(message, {
		style: {
			border: 'none',
			padding: '16px',
			color: 'white',
			background: '#1DBF16',
			boxShadow: 'none',
			borderRadius: 20,
			width: 'calc(100vw - 40px)',
			maxWidth: 700,
			height: 54,
			textAlign: 'left',
		},
		duration: 2000,
	});
